import { Habit, TaskFilterOptions, Timestamp, User } from '@griply/types';
import { filterHabits, getWeekStartsOn } from '@griply/utils';
import { useMemo } from 'react';

export type UseFilteredHabitsInput = {
  habits: Habit[];
  filters: TaskFilterOptions | TaskFilterOptions[];
  today: Timestamp;
  user: User | null | undefined;
};

export const useFilteredHabits = ({
  habits,
  filters,
  today,
  user,
}: UseFilteredHabitsInput): Habit[] => {
  const weekStartsOn = getWeekStartsOn(user);

  return useMemo(() => {
    const filtersArray = Array.isArray(filters) ? filters : [filters];
    return filterHabits({
      habits,
      filters: filtersArray,
      weekStartsOn,
      today,
    });
  }, [filters, habits, today, weekStartsOn]);
};
